import React from "react"
import { graphql, StaticQuery } from "gatsby"
import { Link } from "gatsby"
import Tilt from 'react-vanilla-tilt'

import Layout from "../components/layout"
import SEO from "../components/seo"
import ProjectCard from "../components/projectCard"
import AreasSection from "../components/areas"
import ContactSection from "../components/contactCard"

import "../utils/normalize.css"
import "../utils/css/screen.css"
import "../utils/css/components/areas.css"

import logo from "../../content/assets/logo.png"
import mSvg from "../../content/assets/M-gradient.svg"
import arrowdown from "../../content/assets/arrow-down.svg"
import arrow from "../../content/assets/arrow-right.svg"


const MarketingAreaPage = ({ data }, location) => {
    const siteTitle = data.site.siteMetadata.title
    const projects = data.allStrapiPortfoliolinks.edges

    return (
        <Layout title={siteTitle}>
            <SEO title="Albatross Marketing | Brand Building - Strategy to Execution" 
            keywords={[`branding`, `brand strategy`, `SEO`, `SEM`, `PPC`, `advertising`, `digital marketing`, `online marketing`, `internet marketing`, `marketing consulting`, `marketing communication`, `social media marketing`, `best digital marketing agency in Pune`, `digital marketing agency in Mumbai`, `#1 digital marketing agency in India`]}
            description="Marketing wing of Studio Albatross covers the entire spectrum of digital, inbound and
            outbound marketing. We work as a strategic partner to global brands and act as their extended
            marketing department." />
            <section className="section-header marketing">
            <Link className="site-head-logo" to={`/`}>
                        <img src={logo} alt="Logo" />
                    </Link>
                <div className="mid">
                    <img src={mSvg} alt="Marketing" />
                    <h1>Marketing</h1>
                    <p>Brand building - Strategy to execution.</p>
                </div>
                <img className="arrow-down" src={arrowdown}></img>
            </section>
            <section className="section-description">
                <p>
                    Every brand seeks more eyeballs/customers/Advocates and for that what you need is the focused, personalized and creative approach to your marketing.
</p>
                <p>
                    We, at Studio Albatross, help those thirsty brands who want to build, promote and expand their brand horizons. From devising  marketing strategies to their execution, we cover the entire spectrum of the marketing needs.</p>
                <p className="section-description-focus">
                    A brand creates waves when there is creativity at the core of it.
                </p>
            </section>
            <section className="section-offerings">
                <div className="section-title">
                    Detailed Offerings
                </div>
                <div className="offerings show-web">
                    <ul>
                    <li>Brand consulting</li>
                        <li>Brand launch</li>
                        <li>Web development</li>
                        <li>Social media marketing / management</li>
                        <li>Digital campaigns</li>
                        <li>Brand engagement analysis</li>
                    </ul>
                    <ul>
                        <li>Online enablement</li>
                        <li>Content creation & marketing</li>
                        <li>SEO</li>
                        <li>Digital advertising</li>
                        <li>Events marketing & management</li>
                        <li>SEM</li>
                    </ul>
                </div>
                <div className="offerings show-mob">
                    <ul>
                        <li>Brand consulting</li>
                        <li>Online enablement</li>
                        <li>Brand launch</li>
                        <li>Content creation & marketing</li>
                        <li>Web development</li>
                        <li>SEO</li>
                        <li>Social media marketing / management</li>
                        <li>Digital advertising</li>
                        <li>Digital campaigns</li>
                        <li>Events marketing & management</li>
                        <li>Brand engagement analysis</li>
                        <li>SEM</li>
                    </ul>
                </div>
            </section>
            <section className="section-projects">
                <div className="section-title">
                    Featured Projects
                </div>
                <div className="projects">
                    {projects.map((project, i) => (
                        <div className="project-card" key={i}>
                            <ProjectCard key={i}
                                title={project.node.title}
                                thumbnail={project.node.thumbnail}
                                link={project.node.link}
                                categories={project.node.categories}
                            />
                        </div>
                    ))}
                    <a href="http://studioalbatross.in/projects/" className="project-card">
                        <Tilt options={{ max: 25, scale: 1, glare: true }} style={{ height: '100%', width: '100%' }}>
                            <div className=" more">
                                ALL PROJECTS
                        <img className="arrow" src={arrow} alt="Start" />
                            </div>
                        </Tilt>
                    </a>
                </div>
            </section>
            <AreasSection
                home={false}
                other={true}
                design={true}
                film={true}
                marketing={false}
            ></AreasSection>
            <ContactSection></ContactSection>
        </Layout>
    )
}

const indexQuery = graphql`
query {
    site {
        siteMetadata {
          title
        }
      }
    allStrapiPortfoliolinks(filter: {featured: {eq: true}, categories: {elemMatch: {name: {in: "Marketing"}}}}, limit: 3) {
      edges {
        node {
          id
          link
          title
          enabled
          featured
          thumbnail {
            childImageSharp {
              fluid(maxWidth: 400, maxHeight: 600) {
                ...GatsbyImageSharpFluid
              }
            }
          }
          categories {
            name
          }
        }
      }
    }
  }
`

export default props => (
    <StaticQuery
        query={indexQuery}
        render={data => (
            <MarketingAreaPage location={props.location} data={data} {...props} />
        )}
    />
)
